import { useCallback, useState } from 'react'

// Below this the two-column grid clips card prices and labels; measured on the live page.
export const TWO_COLUMN_MIN_WIDTH_PX = 900

/**
 * Picks the menu card column count from the menu column's own width. The viewport
 * breakpoint can't be used: the fixed-width basket and filter sidebar leave the menu
 * column far narrower than the viewport implies on laptops.
 */
export function useMenuCardColumns() {
  const [cardCols, setCardCols] = useState(1)

  // Callback ref rather than an effect so the observer attaches whenever the list
  // mounts (it can start empty) and the first measurement lands before paint.
  const ref = useCallback((node: HTMLElement | null) => {
    if (!node) {
      return
    }

    const updateColumns = () => {
      setCardCols(node.clientWidth >= TWO_COLUMN_MIN_WIDTH_PX ? 2 : 1)
    }
    updateColumns()

    const observer = new ResizeObserver(updateColumns)
    observer.observe(node)

    return () => {
      observer.disconnect()
    }
  }, [])

  return { ref, cardCols }
}
